import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Set dark mode class before initial render
document.documentElement.classList.add('dark');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
